import usePiano from 'components/integrations/PianoPlacements/hooks/usePiano';
import PianoStickyLink from './partials/PianoStickyLink';
import { useEffect, useState } from 'react';
import useAppContext, { DomainSiteKey } from 'lib/hooks/useAppContext';
import utils from 'lib/utils';
import { PianoEvent } from 'components/integrations/PianoPlacements/types';
import QueryString from 'qs';
import analyticsService from 'services/analytics.service';
import events from 'lib/analytics/mixpanel/events';
import { gtmFireEvent } from 'components/orders/utilities/gtmDataLayerUtils';
import { getSubscriberKeyFromEmail } from 'utils/getSubscriberKeyFromEmail';
import { setCookie } from 'cookies-next';

type AccessPageProps = {
  docTitle: string;
  joinFlowReturn?: string;
  referredIncode?: string;
};

const ppcLandingEvents = (
  e: PianoEvent,
  domainSiteKey: DomainSiteKey,
  queryParams: Record<string, string>,
  joinFlowReturn?: string,
  referredIncode?: string,
) => {
  const { email: emailCapture, mdc } = e.params;
  if (emailCapture && emailCapture.trim()) {
    setCookie('email', emailCapture, { path: '/', maxAge: 300 });
  }

  analyticsService.track(
    events.PPC_LANDING_CLICKED,
    {
      location: 'PPC Landing Page',
      incode: referredIncode,
      mdc: mdc,
    },
    { transport: 'sendBeacon' },
  );

  queryParams['mdc'] = mdc;

  const qp = QueryString.stringify(queryParams);
  const orderEndpoint = `/order?${qp}`;

  const trackEmailRedirect = () => {
    analyticsService.track(
      events.EMAIL_CAPTURE,
      { email: emailCapture, type: 'Join', incode: referredIncode, mdc: mdc },
      { transport: 'sendBeacon' },
    );
    const newForm = document.createElement('form');
    const input = document.createElement('input');
    input.setAttribute('name', 'email');
    input.setAttribute('value', emailCapture);
    const action = utils.checkRelativeLink(domainSiteKey, orderEndpoint);
    newForm.setAttribute('action', action);
    newForm.setAttribute('method', 'POST');
    newForm.style.display = 'none';
    newForm.append(input);
    if (joinFlowReturn) {
      const returnToInput = document.createElement('input');
      returnToInput.setAttribute('name', 'return_to');
      returnToInput.value = joinFlowReturn;
    }
    document.body.append(newForm);
    newForm.submit();
  };

  const brazeEmailCapture = () => {
    const subscriberKeyData = getSubscriberKeyFromEmail(emailCapture);
    if (!subscriberKeyData) throw Error('Missing subscriber key data');
    gtmFireEvent({
      eventName: 'Braze Email Capture',
      properties: {
        Email: emailCapture,
        SubscriberKey: subscriberKeyData.subscriberKey,
      },
    });
  };

  const orderRedirect = (domainSiteKey: DomainSiteKey) => {
    const baseUrl = joinFlowReturn
      ? `${orderEndpoint}&return_to=${joinFlowReturn}`
      : orderEndpoint;
    const href = utils.checkRelativeLink(domainSiteKey, baseUrl);
    return (document.location.href = href);
  };

  switch (e.eventName) {
    case 'welcome-email-signup-button':
      trackEmailRedirect();
      brazeEmailCapture();
      break;
    case 'sign-up-button':
      trackEmailRedirect(); //adding switch for welcome5 refactor
      brazeEmailCapture();
      break;
    case 'link-to-order':
      orderRedirect(domainSiteKey);
      break;
  }
};

const PianoUI = ({
  docTitle,
  joinFlowReturn,
  referredIncode,
}: AccessPageProps) => {
  const [shouldInit, setShouldInit] = useState(false);
  const { domainSiteKey, queryParams } = useAppContext();
  const initPiano = usePiano({
    eventHandlers: [
      (e) => [
        ppcLandingEvents(
          e,
          domainSiteKey,
          queryParams,
          joinFlowReturn,
          referredIncode,
        ),
      ],
    ],
    postHandlers: !shouldInit,
    segment: 'all',
    classesUserSegment: 'none',
  });

  useEffect(() => {
    if (shouldInit && window.tp && typeof initPiano === 'function') {
      initPiano();
    }
    setShouldInit(true);
  }, [initPiano, shouldInit]);

  if (!shouldInit) return null;
  return (
    <>
      <div className={`piano-${docTitle}-offer`}></div>
      <PianoStickyLink />
    </>
  );
};

export default PianoUI;
